import { Link } from 'react-router-dom'
import ContentShell from '../../components/blog/ContentShell'
import Seo from '../../components/blog/Seo'
import Breadcrumbs from '../../components/blog/Breadcrumbs'
import PostCard from '../../components/blog/PostCard'
import { getAllPosts, getAllCategories } from '../../lib/blog/posts'
import { breadcrumbJsonLd } from '../../lib/seo'

export default function BlogIndex() {
  const posts = getAllPosts()
  const categories = getAllCategories()

  return (
    <ContentShell>
      <Seo
        title="Blog | BankStatementReader"
        description="Guides on converting, reconciling, and analyzing bank statements — for bookkeepers, accountants, small businesses, and individuals."
        canonicalPath="/blog"
        jsonLd={[breadcrumbJsonLd([{ name: 'Home', path: '/' }, { name: 'Blog', path: '/blog' }])]}
      />
      <div className="mx-auto max-w-5xl pt-6">
        <Breadcrumbs crumbs={[{ name: 'Home', path: '/' }, { name: 'Blog', path: '/blog' }]} />
        <h1 className="text-[clamp(2rem,3vw+1rem,2.8rem)] font-bold tracking-tight text-ink m-0">Blog</h1>
        <p className="text-ink-soft mt-3 mb-8">
          Practical guides on bank statement conversion, reconciliation, bookkeeping, and more.
        </p>

        {categories.length > 0 && (
          <nav className="flex flex-wrap gap-3 mb-10" aria-label="Categories">
            {categories.map((c) => (
              <Link
                key={c.slug}
                to={`/blog/category/${c.slug}`}
                className="rounded-full bg-surface-muted px-4 py-2 text-[0.85rem] text-ink hover:bg-gray-200 transition"
              >
                {c.label} ({c.count})
              </Link>
            ))}
          </nav>
        )}

        <div className="grid gap-6 md:grid-cols-3">
          {posts.map((p) => (
            <PostCard key={p.slug} post={p} />
          ))}
        </div>
      </div>
    </ContentShell>
  )
}
